import React from 'react';

import { FAQ } from '@shared/faq/faq';

import { ComparisonCards } from './components/comparison_cards';
import { ComparisonGrid } from './components/comparsion_grid';
import { ContentWithSideImage } from './components/content_with_side_image';
import { HowClutterMovingWorks } from './components/how_clutter_moving_works';
import { HowClutterStorageWorks } from './components/how_clutter_storage_works';
import { HowClutterWorks } from './components/how_clutter_works';
import { IconValueProps } from './components/icon_value_props';
import { ImageHero } from './components/image_hero';
import { ReviewCarousel } from './components/review_carousel';
import { ServiceCards } from './components/service_cards';
import { SimpleHeadingCTA } from './components/simple_heading_cta';
import { SocialProof } from './components/social_proof';
import { StandaloneCTA } from './components/standalone_cta';
import { Stats } from './components/stats';

const Components = {
  ImageHero,
  SimpleHeadingCTA,
  IconValueProps,
  ReviewCarousel,
  Stats,
  ComparisonCards,
  FAQ,
  ContentWithSideImage,
  StandaloneCTA,
  ServiceCards,
  HowClutterWorks,
  HowClutterStorageWorks,
  HowClutterMovingWorks,
  ComparisonGrid,
  SocialProof,
};

export type SectionDescriptor = {
  [K in keyof typeof Components]: {
    key: string;
    component: K;
    props: React.ComponentProps<(typeof Components)[K]>;
  };
}[keyof typeof Components];

export const Section = ({
  descriptor,
}: {
  descriptor: SectionDescriptor;
}): React.ReactElement => {
  const Component = Components[descriptor.component];
  return <Component key={descriptor.key} {...(descriptor.props as any)} />;
};
